import { PlayWindow } from "../../api";
import { Rect, Size } from "../../MyHelpers";
import { Resourceful } from "../../ResourceManager/Resourceful";
import { IWriteOnlyResourceManager, IReadOnlyResourceManager } from "../../ResourceManager/ResourceManager";
import * as PIXI from "pixi.js";
import { IAnticipation } from "./AnticipationFactory";

export class AnticipationDefault implements Resourceful, IAnticipation {
    readonly playWindow: PlayWindow = null;
    readonly symbolSize: Size = null;
    readonly gameName: string = "";


    public constructor(playWindow: PlayWindow, symbolSize: Size, gameName: string) {
        this.playWindow = playWindow;
        this.symbolSize = symbolSize;
        this.gameName = gameName
    }
    HideReelAnimation(index: number) {
    }

    Destroy() {
    }
    ShowReelAnimation(index: number) {
    }
    
    Create(reelPositon: Rect[], windowRectangle: Rect) {
        
    }
    PrepareResources(resourceManager: IWriteOnlyResourceManager) {
        
    }
    ResourcesLoaded(resourceManager: IReadOnlyResourceManager) {
       
    }
    public GetView(): PIXI.Container{
        return null;
    }


}